// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3083": "301709ef5f5f","8795": "771c29ae18b2","9578": "8c27974e6424",}[chunkId] + ".css"
}